/**
 * Cross-package Zod schemas. Re-exported via `@fellesen/api/schemas` so the
 * web frontend can validate against the exact same rules the API enforces.
 *
 * Add a schema here only when both sides of the wire need it identically.
 * API-internal schemas (router input shapes that nobody else cares about)
 * stay in their owning router.
 */

import { z } from "zod";

/**
 * Category create/update payload. The API uses this directly; the web app
 * imports it for client-side form validation so the user sees the same
 * limits the server enforces. Field names match the wire format
 * (`matchPatterns` → DB column `match_patterns`).
 */
export const categoryInputSchema = z.object({
  name: z.string().min(1).max(50).trim(),
  icon: z.string().min(1).max(40),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
  defaultShared: z.boolean(),
  matchPatterns: z.array(z.string().min(1).max(60)).max(20),
});

export type CategoryInput = z.infer<typeof categoryInputSchema>;
